import request from '@/utils/request'
import axios from "axios";
// 获取侧边栏类型
export function sidebar(params) {
	return request({
		url: '/discover/sidebar',
		method: 'get',
		params: params
	})
}

// 获取license下拉类型
export function licenseType(params) {
	return request({
		url: `/discover/license/list`,
		method: 'get',
		params: params
	})
}

// 获取数据列表
export function dataList(params) {
	return request({
		url: '/discover/list',
		method: 'post',
		data: params
	})
}

// 获取数据详情
export function getDetail(params) {
	return request({
		url: '/discover/detail',
		method: 'get',
		params: params
	})
}

// 创建资源
export function createResource(params) {
	return request({
		url: '/discover/create',
		method: 'post',
		data: params
	})
}
// 初始化资源
/* 
params secondType   resourceType
 */
export function initializeResource(params) {
	return request({
		url: '/discover//initialize',
		method: 'post',
		data: params
	})
}

// 修改资源
export function updateResource(params) {
	return request({
		url: '/discover/update',
		method: 'post',
		data: params
	})
}

// 删除资源
export function deleteResource(params) {
	return request({
		url: '/discover/delete',
		method: 'post',
		data: params
	})
}

// 获取我的资源侧边栏
export function mySidebar(params) {
	return request({
		url: '/discover/user/sidebar',
		method: 'get'
	})
}

// 获取我的资源
export function myResourceList(params) {
	return request({
		url: '/discover/user/list',
		method: 'post',
		data: params
	})
}

// 收藏资源
export function collectResource(params) {
	return request({
		url: '/discover/collect',
		method: 'get',
		params: params
	})
}
// 取消收藏
export function cancelCollectResource(params) {
	return request({
		url: '/discover/collect/cancel',
		method: 'get',
		params: params
	})
}

// 查询收藏状态
export function collectStatus(params) {
	return request({
		url: '/discover/collect/status',
		method: 'get',
		params: params
	})
}

// 获取栅格详情
export function gridDetail(params) {
	return request({
		url: '/file/raster/detail/fileUuid',
		method: 'get',
		params: params
	})
}

// 更新栅格解析结果
export function updateGridResult(params) {
	return request({
		url: '/file/raster/update',
		method: 'post',
		data: params
	})
}

// 下载埋点
export function downloadPoint(params) {
	return request({
		url: '/discover/download/times',
		method: 'get',
		params: params
	})
}

// 统计四大资源类型
export function overview() {
	return request({
		url: '/discover/overview',
		method: 'get',
	})
}

// 发表评论
export function addComment(params) {
	return request({
		url: '/comment/open-resource/create/top',
		method: 'post',
		data: params
	})
}

// 获取评论列表
export function getComments(params) {
	return request({
		url: '/comment/open-resource/get',
		method: 'get',
		params: params
	})
}

// 回复评论
export function replyComment(params) {
	return request({
		url: '/comment/open-resource/create/child',
		method: 'post',
		data: params
	})
}

// 删除评论
export function deleteComment(params) {
	return request({
		url: '/comment/open-resource/delete',
		method: 'get',
		params: params
	})
}

// 修改资源状态
export function updateStatus(params) {
	return request({
		url: '/discover/is-public',
		method: 'post',
		data: params
	})
}


// Authorize with the app token first; file bytes go directly to object storage.
export async function getResourceFileDownloadUrl(resourceUuid, fileUuid, options = {}) {
    const result = await request({
        url: `/discover/file/${options.management ? "management-download-url" : "download-url"}`,
        method: 'post',
        data: { resourceUuid, fileUuid },
        downloadAuthorization: true,
    });
    if (!result?.data?.downloadUrl) throw new Error("Download URL is missing");
    return result.data.downloadUrl;
}

export async function downloadFile({ resourceUuid, fileUuid }) {
    const url = await getResourceFileDownloadUrl(resourceUuid, fileUuid);
    return axios.get(url, { responseType: "text" });
}

export async function downloadResourceFiles(resourceUuid, fileUuids) {
    const result = await request({
        url: '/discover/file/download-url',
        method: 'post',
        data: { resourceUuid, fileUuids, archive: true },
        timeout: 600000,
        downloadAuthorization: true,
    });
    if (!result?.data?.downloadUrl) throw new Error("Download URL is missing");
    window.location.assign(result.data.downloadUrl);
}

export function updateDownloadPolicy(data) {
    return request({ url: '/discover/file/download-policy', method: 'post', data });
}

// 标签模糊查询
export function getTagSearch(params) {
	return request({
		url: '/discover/tag/search',
		method: 'get',
		params: params
	})
}
// 作者模糊查询
export function getAuthorSearch(params) {
	return request({
		url: '/discover/author/search',
		method: 'get',
		params: params
	})
}

// 初始化开放资源文件上传
export function initOpenResourceFileUpload(params) {
	return request({
		url: '/discover/file/upload/init',
		method: 'post',
		data: params
	})
}

// 完成开放资源文件上传并保存资源关系
export function completeOpenResourceFileUpload(params) {
	return request({
		url: '/discover/file/upload/complete',
		method: 'post',
		data: params
	})
}

// 查询开放资源文件断点续传进度
export function openResourceFileUploadProgress(params) {
	return request({
		url: '/discover/file/progress',
		method: 'get',
		params: params
	})
}

// 更新文件树
export function updateFileTree(params) {
	return request({
		url: '/discover/file/update-tree',
		method: 'post',
		data: params
	})
}
// 删除文件
export function deleteFile(params) {
	return request({
		url: '/discover/file/delete',
		method: 'post',
		data: params
	})
}
// 预览ppt
export function previewPpt(params) {
    return request({
        url: '/discover/file/preview/ppt',
        method: 'post',
        data: params,
        downloadAuthorization: true,
    });
}

// 查询上传进度
// export function checkFile(params) {
// 	return request({
// 		url: '/discover/file/startus',
// 		method: 'get',
// 		params: params
// 	})
// }

// 初始化上传
export function initFile(params) {
	return request({
		url: '/discover/file/chunk/init',
		method: 'post',
		data: params
	})
}

// 分片上传
export function uploadFile(params) {
	return request({
		url: '/discover/file/chunk/upload',
		method: 'post',
		data: params,
	})
}

// 合并文件
export function mergeFile(params) {
	return request({
		url: '/discover/file/merge',
		method: 'post',
		data: params
	})
}

// 热门资源推荐
export function hotResourceList(params) {
	return request({
		url: '/discover/recommend/hot',
		method: 'get',
		params: params
	})
}

// 根据uuid获取用户收藏列表
export function userCollectList(params) {
	return request({
		url: '/discover/user/collect',
		method: 'post',
		data: params
	})
}

// 根据uuid获取用户分享列表
export function userShareList(params) {
	return request({
		url: '/discover/user/create',
		method: 'post',
		data: params
	})
}
